import React, { useState, useEffect } from 'react';
import { Grid, Button, Tooltip, Menu, MenuItem } from '@material-ui/core';
import UserIconImage from 'assets/images/user-icon.svg';
import ThumbUpGrayIcon16 from 'assets/images/thumb-up-gray-16.svg';
import ThumbUpBlueIcon16 from 'assets/images/thumb-up-blue-16.svg';
import { Subpost as SubpostModel } from 'redux/models/subpost';
import { setupReceivingUsers, setupLikes, addDefaultProfileImgSrc } from 'helpers/reactHelper';
import './Subpost.scss';
import { formatPostDate } from 'helpers/helper';
import { getProfilePic } from 'api/requests';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

interface SubpostProps {
	subpost: SubpostModel;
	showAdminItems?: boolean;
	currentUserLikedSubpost: boolean;
	deletingSubpost?: boolean;
	likeSubpostClicked: (teamId: string, postId: string) => void;
	deleteSubpostClicked: (subpost: SubpostModel) => void;
}

const Subpost: React.FC<SubpostProps> = (props: SubpostProps) => {
	const { subpost, showAdminItems, currentUserLikedSubpost, deletingSubpost, likeSubpostClicked, deleteSubpostClicked } = props;
	const [subpostDate, setSubpostDate] = useState<string>('');
	const [authorPic, setAuthorPic] = React.useState<string | undefined>();
	const [menuEl, setMenuEl] = React.useState(null);

	const handleLikeSubpostClicked = () => {
		likeSubpostClicked(subpost.postId, subpost.subpostId);
	};

	const getProfilePicForAuthor = async (authorEmail: string) => {
		const pic = await getProfilePic(authorEmail);
		setAuthorPic(pic);
	};

	const removeSubpostClicked = () => {
		handleCloseMenu();
		deleteSubpostClicked(subpost);
	};

	const handleClickMenu = (event: any) => {
		setMenuEl(event.currentTarget);
	};

	const handleCloseMenu = () => {
		setMenuEl(null);
	};

	useEffect(() => {
		let formattedDate = formatPostDate(subpost.createdOn);
		if (!formattedDate.includes('Today') && !formattedDate.includes('Yesterday')) {
			formattedDate = `on ${formattedDate}`;
		}
		setSubpostDate(formattedDate);
		getProfilePicForAuthor(subpost.authorEmail);
	}, [subpost.createdOn, subpost.authorEmail]);

	return (
		<>
			<Grid container direction='row' className='subpost-item__title'>
				{showAdminItems && (
					<>
						<MoreHorizIcon className='post-more' fontSize='small' aria-controls='simple-menu' aria-haspopup='true' onClick={handleClickMenu} />

						<Menu
							id='simple-menu'
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							getContentAnchorEl={null}
							anchorEl={menuEl}
							keepMounted
							open={Boolean(menuEl)}
							onClose={handleCloseMenu}
						>
							<MenuItem dense disabled={deletingSubpost} onClick={removeSubpostClicked}>
								Delete Subpost
							</MenuItem>
						</Menu>
					</>
				)}

				<Grid className='subpost-item__title-image'>
					{subpost.authorEmail?.length && authorPic ? (
						<img className='post-item__title-image-profile' src={authorPic} onError={e => addDefaultProfileImgSrc(e)} alt='' />
					) : (
						<img src={UserIconImage} alt='user-icon' />
					)}
				</Grid>
				<Grid className='subpost-item__title-content'>
					<div className='subpost-item__title-content-tokens'>+{subpost.tokens} TOKENS</div>
					<div className='subpost-item__title-content-author'>
						from {subpost.authorName} {subpostDate}
					</div>
				</Grid>
			</Grid>
			<Grid container direction='row' justify='space-between' className='subpost-item__footer NoWrap'>
				<Grid className='subpost-item__footer-comment'>
					{setupReceivingUsers(subpost.users)}
					<span className='subpost-item__footer-comment-content'>{subpost.comment}</span>
				</Grid>
				<Tooltip title={setupLikes(subpost.likes)} placement='top'>
					<Button className={`LikeButton ${currentUserLikedSubpost ? 'LikeButton-blue' : ''}`} onClick={() => handleLikeSubpostClicked()}>
						<img src={`${currentUserLikedSubpost ? ThumbUpBlueIcon16 : ThumbUpGrayIcon16}`} alt='thumb-up-icon' />
						<span className='LikeButton-count'>{subpost.likes.length}</span>
					</Button>
				</Tooltip>
			</Grid>
		</>
	);
};

export default Subpost;
